import Vue from "vue";
import {
  MdButton,
  MdField,
  MdRadio,
  MdDatepicker,
  MdDialog,
  MdContent,
  MdCheckbox,
  MdMenu,
  MdList,
  MdChips
} from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

Vue.use(MdButton);
Vue.use(MdField);
Vue.use(MdRadio);
Vue.use(MdDatepicker);
Vue.use(MdDialog);
Vue.use(MdContent);
Vue.use(MdCheckbox);
Vue.use(MdMenu)
Vue.use(MdList)
Vue.use(MdChips)
Vue.component('MdSelect', Vue.options.components.MdSelect.extend({
  methods: {
    isInvalidValue: function isInvalidValue () {
        return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput
    }
  }
}))
